import React, { ReactNode } from 'react';
import MediaQuery from 'react-responsive';

interface Props {
  children: ReactNode;
}

export const DesktopOrLaptop = ({ children }: Props) => <MediaQuery minDeviceWidth={1224}>{children}</MediaQuery>;
export const TabletOrMobile = ({ children }: Props) => <MediaQuery maxDeviceWidth={1224}>{children}</MediaQuery>;
